export default __webpack_public_path__ + "static/media/homeBackground.a779e6bf.svg";